import React from "react";
import { getImageUrl } from "../../../../../utils/imageUtils";
import styles from "./RelatedArticles.module.css";

export const RelatedArticles = ({ relatedArticles, onSelectArticle }) => {
  // Función para formatear la fecha a formato legible
  const formatFecha = (fechaStr) => {
    const date = new Date(fechaStr);
    const opciones = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("es-ES", opciones);
  };

  return (
    <div className={styles.similar}>
      <div className={styles.borderArticulo}>
        <h2 className={styles.tituloArticulo}>Artículos Similares</h2>
        <hr />
        {relatedArticles.length === 0 && <p>No hay artículos similares.</p>}
        {relatedArticles.map((article, i) => (
          <div
            key={article.id || article._id}
            onClick={() => onSelectArticle(article.id || article._id)}
            className={`${i !== 0 ? styles.divider : ""} ${styles.contenedorArticuloSimilar}`}
            style={{ cursor: "pointer" }}
          >
            <div className={styles.contenedorImagen}>
              <img
                className={styles.imagenSimilar}
                src={getImageUrl(article.image, 'thumb')}
                alt={article.title}
              />
            </div>
            <div className={styles.textoSimilar}>
              <h4 className={styles.tituloSimilar}>{article.title}</h4>
              <p className={styles.fechaSimilar}>{formatFecha(article.createdAt)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
